/* Product video (sections/jc-product-video): the <video> is cloned from a <template> on click,
   so nothing video-related downloads before then; it then plays with sound and native controls.
   The cover image stays underneath the video (see assets/jc-video.css). */
(function () {
  if (window.jcVideoInit) return;
  window.jcVideoInit = true;

  function initFacade(frame) {
    var btn = frame.querySelector('[data-jc-video-play]');
    var tpl = frame.querySelector('template[data-jc-video-template]');
    if (!btn || !tpl) return;
    btn.addEventListener('click', function () {
      var video = tpl.content.firstElementChild.cloneNode(true);
      video.preload = 'auto';
      frame.classList.add('is-playing');
      frame.appendChild(video);
      btn.remove();
      var p = video.play(); if (p && p.catch) p.catch(function () {});
      video.focus();
    });
  }

  function init() { document.querySelectorAll('[data-jc-video="facade"]').forEach(initFacade); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
